module.exports = __webpack_public_path__ + "static/media/greater_than_equal_to.316fa4ae.svg";